/**
 * Reads the current StyleSystem colour tokens from the document root so the
 * chart library can use the same primary/accent/success/danger palette that the
 * rest of the app renders with — no hard-coded hex anywhere.
 */
export function useThemeColors() {
  if (typeof document === "undefined") {
    return { primary: "#7a5af5", accent: "#2bb3a3", success: "#1f9d6b", danger: "#d9534f", warning: "#e0a93c", grid: "#e8e8f0", text: "#3a3a4a" };
  }
  const cs = getComputedStyle(document.documentElement);
  const get = (name: string) => {
    const v = cs.getPropertyValue(name).trim();
    return v ? `oklch(${v})` : undefined;
  };
  return {
    primary: get("--primary-500"),
    primary200: get("--primary-200"),
    accent: get("--accent-500"),
    success: get("--success-500"),
    danger: get("--danger-500"),
    warning: get("--warning-500"),
    grid: get("--background-200"),
    text: get("--foreground-500"),
    tooltipBg: get("--foreground-900"),
    tooltipText: get("--background-50"),
  };
}